import { Component, OnInit } from '@angular/core';
import { HighlightService } from 'src/app/@core/services/highligh.service';

@Component({
  selector: 'app-notificaciones',
  templateUrl: './notificaciones.component.html',
  styleUrls: ['./notificaciones.component.scss']
})

export class NotificacionesComponent implements OnInit {
  
  infoComponent: any;
  codeHtml: string;
  highlighted: boolean = false;
  constructor(private highlightService: HighlightService) {
    this.infoComponent = {
      titulo: "Alertas",
      subtitulo: "Comunican al usuario una novedad que puede ser resultado o validación dentro de un proceso. Las notificaciones se visualizarán dentro de la página, cuentan con un botón para cerrarla y se categorizan en: caso de éxito, aviso de relevancia baja, aviso de alta relevancia y caso de error."
    }
    this.codeHtml = `
    <!-- Alerta: caso de éxito -->
  <div class="alert-success-govco alert alert-dismissible fade show" aria-label="Alerta: caso de éxito">
    <button type="button" class="close" data-dismiss="alert" aria-label="Cerrar" title="Cerrar">&times;</button>
    <div class="alert-heading">
      <span class="govco-icon govco-icon-check-cn size-2x"></span>
      <span class="headline-l-govco">Tu cita ha sido agendada</span>
    </div>
  </div>
  <!-- Alerta: aviso de relevancia baja -->
  <div class="alert-primary-govco alert alert-dismissible fade show" aria-label="Alerta informativa">
    <button type="button" class="close" data-dismiss="alert" aria-label="Cerrar" title="Cerrar">&times;</button>
    <div class="alert-heading">
      <span class="govco-icon govco-icon-bell-sound-p size-2x"></span>
      <span class="headline-l-govco">Importante</span>
    </div>
    <p>Trámite virtual está disponible si el certificado académico fue expedido después del año 2010. Para estudios anteriores dirígete personalmente a tu centro de formación.</p>
  </div>
  <!-- Alerta: aviso de relevancia alta -->
  <div class="alert-warning-govco alert alert-dismissible fade show" aria-label="Alerta de advertencia">
    <button type="button" class="close" data-dismiss="alert" aria-label="Cerrar" title="Cerrar">&times;</button>
    <div class="alert-heading">
      <span class="govco-icon govco-icon-exclamation-cn size-2x"></span>
      <span class="headline-l-govco">Importante</span>
    </div>
    <p>Trámite virtual está disponible si el certificado académico fue expedido después del año 2010. Para estudios anteriores dirígete personalmente a tu centro de formación.</p>
  </div>
  <!-- Alerta: caso de error -->
  <div class="alert-wrong-govco alert alert-dismissible fade show" aria-label="Alerta: caso de error">
    <button type="button" class="close" data-dismiss="alert" aria-label="Cerrar" title="Cerrar">&times;</button>
    <div class="alert-heading">
      <span class="govco-icon govco-icon-sad-face-n size-2x"></span>
      <span class="headline-l-govco">Lo sentimos</span>
    </div>
    <div class="alert-content">
      <p>El servicio no se encuentra disponible en este momento, te recomendamos: </p>
      <ol>
        <li>Intentarlo más tarde.</li>
        <li>Recargar la página.</li>
      </ol>
  </div>
  </div>
    `; 
  } 

  ngOnInit() {
    
  }

  ngAfterViewChecked() {
    if (!this.highlighted) {
      this.highlightService.highlightAll();
      this.highlighted = true;
    }
  } 
}
